import React, { Fragment, useEffect } from 'react';
import InputField from "../../Inputs/InputField";
import ErrorLabel from '../../Labels/ErrorLabel';
import Button from '../../Buttons/Button';
import Styles from './SecurityCode.module.scss';
import previousStep from '../../../images/ImagesSA/ButtonIcon/previousStep.png'
import { AuthOTPState } from "../../../store/authOTP/types";
import { FormikProps } from "formik";
import { connect } from "react-redux";
import { addSecurityCode } from "../../../store/authOTP/actions";
import CardContainer from '../../Card/CardContainer';
import classnames from 'classnames';
import { useHistory } from 'react-router-dom';
import { postUserLogin } from '../../../store/authOTP/thunks';
import { ApiResponse } from '../../../services/types';
import AboutUs from '../../../components/ContentPages/AboutUs.SA';

interface SecurityCodeProps {
    nextPage: any,
    formikProps: FormikProps<AuthOTPState>,
    postUserLogin: any,
    addSecurityCode?: any,
    previousPage: any,
    messageResponse: string | React.ReactElement | null
}

const SecurityCode: React.FC<SecurityCodeProps> = (props: SecurityCodeProps) => {

    let errors = props.formikProps.errors;
    let touched = props.formikProps.touched;
    let history = useHistory();

    useEffect(() => {
        props.formikProps.setFieldValue("otp", "");
        props.addSecurityCode("");
    }, []);

    const nextPage = async (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        let hasBeenTouched = props.formikProps.touched.otp;
            if (hasBeenTouched === undefined) {
                props.formikProps.setFieldTouched("otp");
                return;
            }

        let formIsValid = props.formikProps.errors.otp;
            if (formIsValid !== undefined) {
                return;
            }

        let error = props.formikProps.errors.otp;
            if (error !== undefined) {
                return;
            }
        props.addSecurityCode(props.formikProps.values.otp);
        const response: ApiResponse = await props.postUserLogin(props.formikProps.values);
        if (response.StatusCode === 200) {
            history.push('/MedicalAppointment');
        }
    }
    return (
        <Fragment>
            <div className="container">
                <div className={classnames(Styles.marginTitle, "row")}>
                    <div className="col-lg-12 col-sm-12 col-lg-12 col-xs-12">
                        <h5 className={Styles.title}>Bienvenidos a Virtualmente Juntos</h5>
                    </div>
                </div>
                <CardContainer className="col-md-6 col-sm-6 col-lg-6 col-xs-12">
                    <div className="card-body justify-content-center">
                        <div className={classnames(Styles.marginRow, "row")}>
                            <div className={classnames(Styles.noGutters, "col-lg-2 pt-1")}>
                                <button className={Styles.previousStep} type="button" id="btnPrevious" onClick={props.previousPage}>
                                    <img src={previousStep} className="img-fluid" alt="Imagen paso anterior" />
                                </button>
                            </div>
                            <div className={classnames(Styles.noGutters, "col-lg-9")}>
                                <h6 className={classnames(Styles.color, "font-weight-bold")} >Ingrese el código de seguridad</h6>
                            </div>
                        </div>
                        <div className={classnames(Styles.marginRow, "row")}>
                            <div className="col-lg-12">
                                <span className={Styles.color}>Se enviará un código de acceso al mail registrado</span><br/>
                            </div>
                        </div>
                        <div className={classnames(Styles.marginRow, "row")}>
                            <div className="col-lg-12">
                                <InputField
                                    id="otp"
                                    name="otp"
                                    type="text"
                                    placeholder="Código de seguridad"
                                    onChange={props.formikProps.handleChange}
                                    onBlur={props.formikProps.handleBlur}
                                    value={props.formikProps.values.otp}
                                    styleClass={Styles.formControl}
                                />
                                {touched.otp && errors.otp && <ErrorLabel errorMessage={errors.otp} />}
                                { props.messageResponse }
                            </div>
                        </div>
                        <div className={Styles.marginRow}>
                            <Button
                                id=""
                                onClick={nextPage}
                                styleClass={Styles.size + " largetext"}
                                textoButton="Siguiente"
                            />
                        </div>
                        <div className={Styles.marginRow}>
                            <span className={Styles.opacity90 + " " + Styles.spanMessage}>
                                ¿Tienes algún inconveniente?</span><br/>
                            <span>Comunícate a través de nuestros canales de atención</span>
                        </div>
                    </div>
                </CardContainer>
                <div  className={classnames(Styles.marginRow, "row mt-5")}>
                    <AboutUs classNameStyle="col-md-12 col-sm-12 col-lg-12 col-xs-12" />
                </div>
            </div>
        </Fragment>
    );
};
export default connect( null, {addSecurityCode, postUserLogin})(SecurityCode);
